export default function SET_DETAILED_CLASSROOM_INFORMATION(state, classRoomData) {
    state.classRoom = classRoomData;
}